import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Button, Typography } from '@mui/material'
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom';

// COMPONENT
import * as styled from '../../../style/main.style'
import Header from '../../../Header'
import Navbar from '../../../Navbar'
import InputTextField from '../../../../../component/input/inputTextField'
import { RouteImage } from '../../../../../assets/routeImage'
import { ButtonContained, ButtonOutlined } from '../../../../../component/mui-custom/MuiCustom'
import { notification } from '../../../../../constants/notificationMessage'
import { setLoading, unsetLoading } from '../../../../../store/slice/loading/loading.slice';
import Loading from '../../../../../component/loading/Loading';

// API
import { FiscalYearApi, updateProgressIndicator } from '../../../../../api/fiscal-year/fiscalyear.api';
import { swalSuccess } from '../../../../../component/notification/swal';
import { DetailAccordion, MainAccordion, TopicAccordion } from '../../../../../component/accordion/accordion.custom';
import { colors } from '../../../../../constants/colors';

const ProjectProgressSetting: React.FC = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch()
    const idFiscalYear = useSelector((state: any) => state?.fiscalYear?.idFiscalYear);
    const isLoading = useSelector((state: any) => state?.loading?.isLoading);
    const permission = useSelector((state: any) => state?.permission?.permission);

    type progressIndicatorType = {
        id: string;
        min: number;
        max: number;
        result: number;
        remark: string;
        isShow: boolean;
    };

    const [progressIndicator, setProgressIndicator] = useState<updateProgressIndicator>({
        details: []
    });


    const handleAddProgressIndicator = () => {
        let newProgressIndicator: progressIndicatorType = {
            id: uuidv4(),
            min: 0,
            max: 0,
            result: 0,
            remark: "",
            isShow: true
        }
        setProgressIndicator((prev) => {
            return {
                ...prev,
                details: [...prev.details, newProgressIndicator]
            }
        });
    }
    const handleChangeProgressIndicator = (name: string, id: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
        setProgressIndicator((prev) => {
            return {
                ...prev,
                details: prev.details.map((list: any) => {
                    if (list.id === id) {
                        return {
                            ...list,
                            [name]: name === 'remark' ? event.target.value : Number(event.target.value)
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }
    const handleToggleShowProgressIndicator = (id: string) => {
        setProgressIndicator((prev) => {
            return {
                ...prev,
                details: prev.details.map((list: any) => {
                    if (list?.id === id) {
                        return {
                            ...list,
                            isShow: !list?.isShow
                        }
                    } else {
                        return {
                            ...list
                        }
                    }
                })
            }
        })
    }

    const handleDeleteAchievement = (id: string) => {
        const filterDelete = progressIndicator.details.filter((list: any) => list.id !== id)
        setProgressIndicator((prev) => {
            return {
                ...prev,
                details: filterDelete
            }
        })
    }


    // API
    const handleGetProgressIndicator = async () => {
        dispatch(setLoading())
        await FiscalYearApi.getProgressIndicator(idFiscalYear)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    setProgressIndicator((prev) => {
                        return {
                            ...res?.data?.result,
                            details: res.data?.result?.details?.map((list: progressIndicatorType) => {
                                return {
                                    ...list,
                                    id: uuidv4(),
                                    isShow: true
                                }
                            })
                        }
                    })
                    // setProgressIndicator(updatedDetails)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })
    }
    const handleUpdateProgressIndicator = async () => {
        dispatch(setLoading())
        let condition: updateProgressIndicator = {
            details: progressIndicator.details?.map((list) => {
                return {
                    max: Number(list?.max),
                    min: Number(list?.min),
                    remark: list?.remark,
                    result: Number(list?.result)
                }
            })
        }
        await FiscalYearApi.updateProgressIndicator(idFiscalYear, condition)
            .then(res => {
                if (res.status === 200) {
                    dispatch(unsetLoading())
                    swalSuccess(res.data?.description)
                    console.log(res.data)
                }
            })
            .catch(error => {
                dispatch(unsetLoading())
                console.log(error)
            })

    }

    useEffect(() => {
        handleGetProgressIndicator()
    }, [])

    return (
        <styled.ContainerHome>
            {isLoading === true && <Loading />}
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <styled.TopicHeader>
                        <Link to={'/auth/setting/fiscal-year'}>
                            <Typography className='text-primary' variant='h4'>
                                {`ปีงบประมาณ ${idFiscalYear === 0 ? '' : idFiscalYear} / ผลสัมฤทธิ์ความคืบหน้าโครงการ`}
                            </Typography>
                        </Link>
                        {permission?.find((list: any) => list?.code === "ProjectProgress.Edit")?.permit === true && (
                            <span>
                                <ButtonOutlined
                                    sx={{'&:disabled':{
                                        backgroundColor:colors.disabledLightGray,
                                        border:"none"
                                    }}}
                                    className='disabled:border-none disabled:bg-light group'
                                    disabled={progressIndicator.details.length >= 5}
                                    onClick={handleAddProgressIndicator}>
                                    <Typography className='text-primary group-disabled:text-white'> {t("BUTTON.ADD")}</Typography>
                                </ButtonOutlined>
                                <ButtonContained
                                    onClick={handleUpdateProgressIndicator}
                                >
                                    <Typography>{t("BUTTON.SAVE")}</Typography>
                                </ButtonContained>
                            </span>
                        )}
                    </styled.TopicHeader>

                    {progressIndicator && progressIndicator.details.map((list: any, index: number) => (
                        <section
                            key={index}
                            className={`w-full flex flex-col group p-3 mt-8 border-[1px] gap-3 border-light rounded-lg duration-200 shadow-md h-auto`}>
                            <MainAccordion
                                defaultExpanded
                            >
                                <TopicAccordion
                                    expandIcon={<img src={RouteImage.downArrow} alt="drop-down" />}
                                >
                                    <span>
                                        <Typography variant='h6'>
                                            {`ผลสัมฤทธิ์ช่วงที่ ${index + 1}`}
                                        </Typography>
                                    </span>
                                </TopicAccordion>
                                <DetailAccordion>
                                    <>
                                        <main className='w-full flex gap-3 items-center flex-col md:flex-row'>
                                            <span className='w-full md:max-w-[89px]'>
                                                <InputTextField
                                                    onkeypress={(even) => {
                                                        if (!/[0-9]/.test(even.key)) {
                                                            even.preventDefault();
                                                        }
                                                    }}
                                                    onchange={handleChangeProgressIndicator('min', list?.id)}
                                                    inputTextAlign='center'
                                                    value={Number(list.min).toFixed()}
                                                    endAdornment={<div>{"%"}</div>}
                                                    heading='ผลสัมฤทธิ์'
                                                />
                                            </span>
                                            <span className='mt-7'>
                                                <Typography>{"ถึง"}</Typography>
                                            </span>
                                            <span className='w-full md:max-w-[89px]'>
                                                <InputTextField
                                                    onkeypress={(even) => {
                                                        if (!/[0-9]/.test(even.key)) {
                                                            even.preventDefault();
                                                        }
                                                    }}
                                                    onchange={handleChangeProgressIndicator('max', list?.id)}
                                                    inputTextAlign='center'
                                                    value={Number(list.max).toFixed()}
                                                    endAdornment={<div>{"%"}</div>}
                                                    heading='ผลสัมฤทธิ์' />
                                            </span>
                                            <span className='mt-7'>
                                                <Typography>{"="}</Typography>
                                            </span>
                                            <span className='w-full md:max-w-[100px]'>
                                                <InputTextField
                                                    onkeypress={(even) => {
                                                        if (!/[0-9]/.test(even.key)) {
                                                            even.preventDefault();
                                                        }
                                                    }}
                                                    onchange={handleChangeProgressIndicator('result', list?.id)}
                                                    inputTextAlign='center'
                                                    value={list.result}
                                                    heading='เกณฑ์คุณภาพ' />
                                            </span>
                                        </main>
                                        <div className='w-full mt-2'>
                                            <InputTextField
                                                onchange={handleChangeProgressIndicator('remark', list?.id)}
                                                value={list.remark}
                                                heading='คำอธิบายเกณฑ์คุณภาพ' />
                                        </div>
                                        <Box className="flex justify-end items-center">
                                            {permission?.find((list: any) => list?.code === "ProjectProgress.Edit")?.permit === true && (
                                                <Button
                                                    onClick={() => handleDeleteAchievement(list?.id)}
                                                    endIcon={<img src={RouteImage.delete} />}
                                                >
                                                    <Typography className='text-base_secondary'>
                                                        {notification.file.deleteStatus}
                                                    </Typography>
                                                </Button>
                                            )}
                                        </Box>
                                    </>
                                </DetailAccordion>
                            </MainAccordion>
                        </section>
                    ))}
                </styled.Content>
            </styled.MainContainer>
        </styled.ContainerHome>
    )
}

export default ProjectProgressSetting